// @mui
import { Box, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';

// ----------------------------------------------------------------------

export default function BlockContent({ withIllustration = true }) {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'column' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'center' } }}
    >
      {withIllustration && <UploadIllustration sx={{ width: 150 }} />}

      <Box sx={{ p: 3 }}>
        <Typography variant="body3" sx={{ color: 'text.secondary' }}>
          فایل را اینجا رها کنید و یا در این کادر کلیک نمایید
        </Typography>
      </Box>
    </Stack>
  );
}
